<div class="panel-flex">
  <content-panel>
    <panel-header heading="Support" />
    <panel-body>
      <div class="support-sections">
        @if(isEcAdmin) {
          <div class="support-section-card">
            <app-energy-credit-support />
          </div>
        }
        @if(isQBuiltAdmin){
          <div class="support-section-card">
            <app-qbuilt-support />
          </div>
        }
      </div>
    </panel-body>
  </content-panel>
</div>
